import { IdpConfig } from './config';
import { createMockIdpProvider } from './mock-provider';
import { createKeycloakIdpProvider } from './oidc-provider';
import { IdpAuthError, IdpProvider } from './provider';

/**
 * Escolhe a implementacao de `IdpProvider` pela configuracao do build.
 *
 * `keycloak` e o default quando a flag esta ligada: cair no duble por omissao
 * e como um ambiente de verdade autentica contra um IDP que nao existe.
 */
export function getIdpProvider(config: IdpConfig): IdpProvider {
  if (config.authProvider === 'mock') {
    return createMockIdpProvider({
      clientId: config.clientId,
      semVinculo: config.mockSemVinculo,
      ...(config.mockAccessTokenTtl !== undefined && {
        accessTokenTtl: config.mockAccessTokenTtl,
      }),
      ...(config.mockFalha !== undefined && { falha: config.mockFalha }),
    });
  }

  if (config.issuer === undefined) {
    throw new IdpAuthError(
      'issuer_ausente',
      'REACT_APP_IDP_ISSUER nao configurado. Aponte para o realm do IDP.',
    );
  }

  return createKeycloakIdpProvider({ issuer: config.issuer, clientId: config.clientId });
}
